module.exports = __webpack_public_path__ + "img/valid-payment-link.45197eeb.svg";